/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_PAGE_CONTENT: {
    size: 10,
    offset: 0,
    where: [],
  },
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.boilerplate.profile',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'CAN_CREATE' },
      },
    },
    CAN_CREATE: {
      invoke: {
        id: 'canCreateNewApp',
        src: 'canCreateNewApp',
        onDone: {
          target: 'CAN_CREATE_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'CAN_CREATE_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    CAN_CREATE_SUCCESS: {
      on: { START: { target: 'CAN_CREATE' } },
    },
    CAN_CREATE_ERROR: {
      on: { START: { target: 'CAN_CREATE' } },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
